import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './theme';
import { RatingsVisibilityProvider } from './ratingsVisibility';
import { initI18n } from './i18n';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root não encontrado no index.html');

// O i18next é inicializado antes de montar: montar primeiro faria a interface
// aparecer com as chaves cruas ("shell.tagline") por um quadro.
// Registrado depois da montagem, não antes: o service worker não é necessário
// para a primeira renderização, e registrá-lo primeiro só atrasaria a tela.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Sem service worker o app funciona igual, só não abre offline. Não é
      // motivo para poluir o console de quem usa.
    });
  });
}

void initI18n().then(() => {
  createRoot(root).render(
    <StrictMode>
      <ThemeProvider>
        <RatingsVisibilityProvider>
          <App />
        </RatingsVisibilityProvider>
      </ThemeProvider>
    </StrictMode>,
  );
});
